// extracted by mini-css-extract-plugin
module.exports = {"center":"Table_center__k_G5c"};